"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorRdfMetadataExtractServerSoftware = void 0;
const bus_rdf_metadata_extract_1 = require("@comunica/bus-rdf-metadata-extract");
const core_1 = require("@comunica/core");
/**
 * A comunica Server Software RDF Metadata Extract Actor.
 */
class ActorRdfMetadataExtractServerSoftware extends bus_rdf_metadata_extract_1.ActorRdfMetadataExtract {
    constructor(args) {
        super(args);
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const metadata = {};
        const serverHeader = action.headers?.get('server');
        if (serverHeader) {
            metadata.serverSoftware = serverHeader;
        }
        return { metadata };
    }
}
exports.ActorRdfMetadataExtractServerSoftware = ActorRdfMetadataExtractServerSoftware;
//# sourceMappingURL=ActorRdfMetadataExtractServerSoftware.js.map